import { project2BaseUrl } from "./remoteClient";

export async function getCareerClusters(session) {
    return await project2BaseUrl.get(`/administration/getCareerClusters`, {
        headers: {
            Authorization: `Bearer ${session}`
        }
    })
}